import { buildWhatsAppHref } from "@/lib/whatsapp";

export type PrescriptionOwnerPhone = {
  id?: string | null;
  phone_number?: string | null;
  is_primary?: boolean | null;
  is_whatsapp?: boolean | null;
  deleted_at?: string | null;
};

export type PrescriptionOwnerSummary = {
  id?: string | null;
  name?: string | null;
  phones?: PrescriptionOwnerPhone[] | null;
};

export type PrescriptionShareable = {
  id: string;
  signed_at?: string | null;
  access_code?: string | null;
  access_code_hint?: string | null;
  signed_storage_bucket?: string | null;
  signed_storage_path?: string | null;
  pets?: {
    name?: string | null;
    owners?: PrescriptionOwnerSummary | null;
  } | null;
};

export function getPrescriptionValidationUrl(prescriptionId: string) {
  void prescriptionId;
  return "https://validar.iti.gov.br/";
}

export function getPrescriptionSignedPublicUrl(prescription: PrescriptionShareable) {
  if (!prescription.id || !prescription.access_code) return null;

  if (typeof window === "undefined") return null;

  const origin = window.location.origin.replace(/\/$/, "");
  return `${origin}/prescricao/${prescription.id}/${encodeURIComponent(prescription.access_code)}.pdf`;
}

export function getPrescriptionStatus(prescription: {
  signed_at?: string | null;
}) {
  return prescription.signed_at ? ("signed" as const) : ("draft_issued" as const);
}

export function getPrescriptionOwnerPhones(prescription: PrescriptionShareable) {
  const phones = prescription.pets?.owners?.phones ?? [];

  return phones
    .filter((phone) => phone?.deleted_at == null && phone?.phone_number)
    .sort((a, b) => {
      const score = (phone: PrescriptionOwnerPhone) => {
        if (phone.is_whatsapp && phone.is_primary) return 0;
        if (phone.is_whatsapp) return 1;
        if (phone.is_primary) return 2;
        return 3;
      };
      return score(a) - score(b);
    });
}

export function buildPrescriptionShareMessage(prescription: PrescriptionShareable, signedPdfUrl?: string | null) {
  const petName = prescription.pets?.name?.trim() || "paciente";
  const lines = [
    `Olá, aqui está a receita do(a) ${petName}.`,
    signedPdfUrl ? "Utilize o link abaixo abrir a receita." : null,
    signedPdfUrl ?? null,
  ].filter(Boolean);

  return lines.join("\n");
}

export async function getSignedPrescriptionUrl(prescription: PrescriptionShareable) {
  const publicUrl = getPrescriptionSignedPublicUrl(prescription);
  if (publicUrl) return publicUrl;
  if (!prescription.signed_storage_path) return null;
  return null;
}

export async function sharePrescription({
  prescription,
  phoneNumber,
  signedPdfUrl,
  message,
}: {
  prescription: PrescriptionShareable;
  phoneNumber: string;
  signedPdfUrl: string;
  message: string;
}): Promise<void> {
  void prescription;
  void signedPdfUrl;

  const href = buildWhatsAppHref(phoneNumber, { text: message });
  if (!href) throw new Error("invalid_phone");

  window.open(href, "_blank", "noopener,noreferrer");
}
